import { html, LitElement } from "lit";
import { customElement } from "lit/decorators.js";

import styles from "./blockquote.css";

@customElement("bp-blockquote")
export class BlockQuote extends LitElement {
  static styles = styles;

  render() {
    return html`
      <figure>
        <blockquote>
          <slot></slot>
        </blockquote>

        <slot name="caption"></slot>
      </figure>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-blockquote": BlockQuote;
  }
}
